import * as React from 'react'

import print from './../../images/print.png'
import view from './../../images/view-report.png'
import email from './../../images/email.png'
import './../../styles/recordings/reportOptions.css'


class ReportOptions extends React.Component {
  render () {
    return (
      <div className='reportContainer'>
        <div className='reportHeader'>
          <p>Report Options</p>
        </div>
        <div className='optionContainer'>
          <button className='optionOne'>
          <img src={view} alt=''/>
            View Report
          </button>
          <button className='optionTwo'>
            <img src={print} alt=''/>
            Print Report
          </button>
          <button className='optionOne'>
            <img src={email} alt=''/>
            Email Report
          </button>
        </div>
      </div>
    )
  }
}

export default ReportOptions



// WEBPACK FOOTER //
// ./src/components/recordings/reportOptions.js